import React from "react";
import {
  ActionButton,
  DisabledAction,
  ExternalActionLink,
  InternalActionLink,
} from "./TableAction.styles";
import type { TableActionProps } from "./TableAction.types";

const TableAction: React.FC<TableActionProps> = ({
  href,
  queryParams,
  children,
  text,
  disabled = false,
  onClick,
  ariaLabel,
}) => {
  const label = children ?? text ?? "Смотреть";
  const queryString = queryParams
    ? `?${new URLSearchParams(queryParams).toString()}`
    : "";
  const target = href ? `${href}${queryString}` : undefined;

  if (disabled) {
    return (
      <DisabledAction aria-disabled="true" aria-label={ariaLabel}>
        {label}
      </DisabledAction>
    );
  }

  if (target && /^https?:\/\//i.test(target)) {
    return (
      <ExternalActionLink href={target} target="_blank" rel="noopener noreferrer" aria-label={ariaLabel}>
        {label}
      </ExternalActionLink>
    );
  }

  if (target) {
    return (
      <InternalActionLink to={target} aria-label={ariaLabel}>
        {label}
      </InternalActionLink>
    );
  }

  return (
    <ActionButton type="button" onClick={onClick} aria-label={ariaLabel}>
      {label}
    </ActionButton>
  );
};

export default TableAction;
